/* eslint-disable react-perf/jsx-no-new-object-as-prop */
import React from 'react';
import LoadingFullScreen from 'react-fullscreen-loading';

function Loading() {
    return <LoadingFullScreen loading background="rgba(0,0,0,0.1)" loaderColor="#E5195A" tex />;
}

export default Loading;
